var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGcmAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5 129C100.122 129 129 100.122 129 64.5C129 28.8776 100.122 0 64.5 0C28.8776 0 0 28.8776 0 64.5C0 100.122 28.8776 129 64.5 129Z",
    fill: "#d96c0b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5012 32.7461C67.0457 32.7461 69.1428 35.1403 69.4294 38.2247L69.4627 38.948V76.1595C69.4627 79.5848 67.2414 82.3615 64.5012 82.3615C61.9568 82.3615 59.8597 79.9673 59.5731 76.8828L59.5397 76.1595V38.948C59.5397 35.5228 61.761 32.7461 64.5012 32.7461Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5012 102.208C67.2414 102.208 69.4627 99.9861 69.4627 97.246C69.4627 94.5058 67.2414 92.2844 64.5012 92.2844C61.761 92.2844 59.5397 94.5058 59.5397 97.246C59.5397 99.9861 61.761 102.208 64.5012 102.208Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcmAlert);
export default __webpack_public_path__ + "static/media/gcm-alert.7a5c6f2e.svg";
export { ForwardRef as ReactComponent };